import { MoreVert, VisibilityOff } from "@mui/icons-material";
import {
  Box, Button, IconButton, Link, ListItemIcon, Menu, MenuItem,
} from "@mui/material";
import { differenceInCalendarDays } from "date-fns";
import _ from "lodash";
import React from "react";
import { useMutation } from "react-fetching-library";
import { useTranslation } from "react-i18next";

import { apiAction } from "../../../../../../services/api/index.js";
import { planCustomerHidePut } from "../../../../../../services/api/plan.js";
import { intervals } from "../../../../../../services/enums/index.js";
import { useAnchorControl } from "../../../../../../services/hooks/index.js";
import { competitionAbsoluteUrl } from "../../../../../../services/routes.js";
import { DateSelectButton } from "../../../../../shared/buttons/index.js";

export default React.memo(({
  plan, shift, setShift, setPrevShift, reloadPlans,
}) => {
  const { t } = useTranslation();
  const { anchorEl, setAnchor, removeAnchor } = useAnchorControl();
  const { mutate, loading, status } = useMutation(apiAction);

  React.useEffect(() => {
    if (status === 200) {
      reloadPlans();
    }
  }, [status]);

  return (
    <>
      {_.isEqual(plan.interval, intervals.COMPETITION) && (
      <Box flex="0 0" display="flex" flexDirection="column" justifyContent="center">
        <Link href={competitionAbsoluteUrl(plan)} rel="noopener noreferrer">
          <Button variant="contained" style={{ whiteSpace: "nowrap" }}>{t("competition")}</Button>
        </Link>
      </Box>
      )}
      {_.isEqual(plan.interval, intervals.DAILY) && (
      <Box flex="0 0" display="flex" flexDirection="column" justifyContent="center">
        <DateSelectButton
          color="secondary"
          right={-36}
          top={-1}
          disableFuture
          onChange={val => {
            setPrevShift(shift);
            setShift(differenceInCalendarDays(val, new Date()));
          }}
        />
      </Box>
      )}
      <Box flex="0 0" display="flex" flexDirection="column" justifyContent="center">
        <IconButton aria-controls={`menu-${plan._id}`} aria-haspopup="true" onClick={setAnchor} style={{ marginLeft: "5px" }}>
          <MoreVert fontSize="small" />
        </IconButton>
        <Menu
          id={`menu-${plan._id}`}
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={removeAnchor}
        >
          <MenuItem
            data-testid="plan-shares"
            disabled={loading}
            onClick={() => {
              mutate(...planCustomerHidePut(plan._id));
              removeAnchor();
            }}
          >
            <ListItemIcon>
              <VisibilityOff fontSize="small" />
            </ListItemIcon>
            {t("hide")}
          </MenuItem>
        </Menu>
      </Box>
    </>
  );
});
